<template>
    <landing-state :state="AvailableState.error" :title="t('error')" :message1="t('contactSupport')"></landing-state>
</template>

<script lang="ts" setup>
    import LandingState from '@/components/LandingState/LandingState.vue';
    import { useI18n } from 'vue-i18n';
    import { AvailableState } from '@/interfaces/enums/states';

    const { t } = useI18n({ useScope: 'global' });
</script>

<style lang="scss"></style>
